import React from 'react';
import { MenuList as MuiMenuList } from '@mui/material';

interface CustomMenuListProps {
  children: React.ReactNode;
  className?: string;
}

const CustomMenuList: React.FC<CustomMenuListProps> = ({
  children,
  className,
  ...props
}) => {
  return (
    <MuiMenuList className={className} {...props}>
      {children}
    </MuiMenuList>
  );
};

export default CustomMenuList;
